import { styled } from '@mui/material';
import TextField from '@mui/material/TextField';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    background: 'transparent',
    color: theme.palette.primary.p080,
    height: '56px',
    boxShadow: 'none',
    borderRadius: '8px',
    width: '250px',
    [theme.breakpoints.down('mobile')]: {
      width: '100%',
      minWidth: 0,
    },
    border: '1px solid rgba(0, 0, 0, 0.15)',
  },

  '& .MuiInputBase-input': {
    padding: '0 12px',
    height: '40px',
    fontSize: '15px',
    fontWeight: 500,
  },

  input: {
    // to remove arrow from number input
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
    '&::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },

  '.MuiFormHelperText-root.Mui-error': {
    top: '-24px',
    position: 'absolute',
    fontSize: '16px',
    lineHeight: '18px',
  },

  '.MuiFormLabel-root': {
    top: '12px',
    position: 'absolute',
  },

  [theme.breakpoints.down('desktop')]: {
    '& .MuiInputBase-input': {
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '24px',
      height: 'unset',
      padding: '18px 32px 18px 18px',
    },
    '& .MuiInputBase-root.Mui-error': {
      border: '1px solid #FF9900',
    },
    '.MuiFormHelperText-root.Mui-error': {
      top: '3px',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '14px',
      left: '20px',
    },
  },

  '& .MuiInputBase-root.Mui-disabled': {
    overflow: 'hidden',
    backdropFilter: 'blur(10px)',

    '& .MuiSelect-select.MuiSelect-select': {
      background: theme.palette.primary.p050,
      opacity: '0.2',
      cursor: 'not-allowed',
    },
  },
}));
